import React from "react";
import { Link } from "react-router-dom";

export default function NavItem({
  label,
  Icon,
  active,
  isCollapsed,
  to,
  state,
}) {
  return (
    <Link
      to={to}
      state={state}
      title={isCollapsed ? label : undefined}
      className={`group relative w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-sm font-medium ${
        active
          ? "bg-white/15 text-white shadow-inner shadow-black/5"
          : "text-teal-50/80 hover:bg-white/5 hover:text-white"
      } ${isCollapsed ? "justify-center" : ""}`}>
      {/* Active pill indicator */}
      {active && (
        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-white rounded-r-full" />
      )}

      <Icon
        className={`w-[18px] h-[18px] shrink-0 transition-colors ${active ? "text-white" : "text-teal-100/80 group-hover:text-white"}`}
      />
      {!isCollapsed && <span className="truncate">{label}</span>}
    </Link>
  );
}
